import {useState} from "react";
import styled from 'styled-components/macro';

import {useFeedback} from "../store/feedback";
import {useActions} from "../store";
import {useDeleteUserFlair, useFlairs, useSetUserFlair} from "../api/flairs";
import {useUsername} from "../store/hooks";
import PopupMenu from "./popup_menu";
import Spinner from "./spinner";

const Item = styled.div``;
const Save = styled.div``;
const Flairs = styled.div``;

const FlairUser = styled(({className, community, onClose}) => {
    const actions = useActions();
    const username = useUsername();
    const loading = useFeedback();
    const flairs = useFlairs(loading.channel, community, "user");
    const [flairSelection, setFlairSelection] = useState();
    const saving = useFeedback();
    const setUserFlair = useSetUserFlair(saving.channel);
    const deleteUserFlair = useDeleteUserFlair(saving.channel);
    const handleFlair = async () => {
        onClose();
        if (flairSelection) {
            await setUserFlair(username, community, flairSelection.text, flairSelection.class);
        } else {
            await deleteUserFlair(username, community);
        }
    };
    return (
        <PopupMenu onClose={onClose} className={className} heading={'Set your user flair'} description={'Displayed next to your username'} height={500} width={420}>
            <Flairs>
                {loading.busy && <Spinner/>}
                {flairs?.map((flair) => (
                    <Item key={flair.class}>
                        <input id={`flair_${flair.class}`} type="radio" name="flair" onChange={() => setFlairSelection(flair)} />
                        <label htmlFor={`flair_${flair.class}`} className='post-flair' data-flair={flair.class}>
                            {flair.text}
                        </label>
                    </Item>
                ))}
            </Flairs>
            <Save onClick={handleFlair}>Save</Save>
        </PopupMenu>
    )})`
  ${Save} {
    margin-top: auto;
    background-color: ${({theme}) => theme.placeholder_white_2};
    text-align: center;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
  }
  ${Item} {
    width: 48%;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 8px;
  }
  ${Item}:first-of-type {
    margin-top: 0;
  }
  ${Item} svg {
    margin-right: 16px;
    font-size: 26px;
  }
  ${Flairs} {
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    justify-content: space-between;
    align-items: center;
  }
  input[type="radio"] {
    visibility: hidden;
  }
  input[type="radio"]:checked + label {
    font-weight: 500;
  }
`;

export default FlairUser;
